import {
  BookOpenIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  CircleStackIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  NewspaperIcon,
  PresentationChartLineIcon,
  RocketLaunchIcon,
  ShareIcon,
} from '@heroicons/react/24/outline';
import type { DocsIconKey, InsightsIconKey } from './navMenuConfig';

const ICON_CLASS = 'nav-mega-docs-item__icon-svg';

export function DocsMenuIcon({ icon }: { icon: DocsIconKey }) {
  switch (icon) {
    case 'book':
      return <BookOpenIcon className={ICON_CLASS} aria-hidden />;
    case 'rocket':
      return <RocketLaunchIcon className={ICON_CLASS} aria-hidden />;
    case 'chart':
      return <ChartBarIcon className={ICON_CLASS} aria-hidden />;
    case 'database':
      return <CircleStackIcon className={ICON_CLASS} aria-hidden />;
    case 'metrics':
      return <PresentationChartLineIcon className={ICON_CLASS} aria-hidden />;
    case 'document':
      return <DocumentTextIcon className={ICON_CLASS} aria-hidden />;
    case 'ontology':
      return <ShareIcon className={ICON_CLASS} aria-hidden />;
    default:
      return <CircleStackIcon className={ICON_CLASS} aria-hidden />;
  }
}

export function InsightsMenuIcon({ icon }: { icon: InsightsIconKey }) {
  switch (icon) {
    case 'caseStudies':
      return <ClipboardDocumentListIcon className={ICON_CLASS} aria-hidden />;
    case 'publications':
      return <BookOpenIcon className={ICON_CLASS} aria-hidden />;
    case 'events':
      return <CalendarDaysIcon className={ICON_CLASS} aria-hidden />;
    case 'blog':
      return <NewspaperIcon className={ICON_CLASS} aria-hidden />;
    default:
      return <DocumentTextIcon className={ICON_CLASS} aria-hidden />;
  }
}
